import React from 'react';
import { FormikProps } from 'formik';
import { Modal } from '../../../components';
import { Switch } from '../../../components/primitives';
import { IProductInitialValuesProps } from '../types';

type ContentChangeResponse = {
  title: boolean;
  description: boolean;
  options: boolean;
}

interface ContentReviewModalProps {
  props: FormikProps<IProductInitialValuesProps>;
  contentModified: ContentChangeResponse | false;
  showContentReviewModal: boolean;
  setShowContentReviewModal: (_show: boolean) => void;
  disableProductUntilChangesAccepted: boolean;
  setDisableProductUntilChangesAccepted: (_disable: boolean) => void;
}

export const ContentReviewModal: React.FC<ContentReviewModalProps> = ({
  props,
  contentModified,
  showContentReviewModal,
  setShowContentReviewModal,
  disableProductUntilChangesAccepted,
  setDisableProductUntilChangesAccepted,
}) => {
  return (
    <Modal
      open={showContentReviewModal}
      onClose={() => {
        setShowContentReviewModal(false);
      }}
      title="Product Review Required"
      footer={true}
      primaryAction={{
        label: 'Save',
        variant: 'primary',
        onClick: () => {
          setShowContentReviewModal(false);
          props.submitForm();
        },
      }}
      secondaryActions={{
        label: 'Dismiss',
        variant: 'outline',
        onClick: () => {
          setShowContentReviewModal(false);
        },
      }}
    >
      <div>
        <div className="mt-4">
          You have made changes which require review:
          <ul className="mt-4 mb-4 ml-8 font-semibold text-muted-foreground list-disc text-md">
            {contentModified && contentModified.title && <li className="mb-2">Title</li>}
            {contentModified && contentModified.description && <li className="mb-2">Description</li>}
            {contentModified && contentModified.options && <li className="mb-2">Options</li>}
          </ul>
        </div>
        <p className="mb-4">All changes will be pending review. This includes changes to available quantities.</p>
        <p className="mb-4">You can make your product inactive until the changes are accepted below:</p>
        <div className="mb-4 ml-4 flex items-center gap-3">
          <Switch
            id="disable-until-changes-accepted"
            checked={disableProductUntilChangesAccepted}
            onCheckedChange={(checked) => {
              setDisableProductUntilChangesAccepted(checked);
            }}
          />
          <label htmlFor="disable-until-changes-accepted" className="text-sm text-foreground">
            Disable product until changes are accepted
          </label>
        </div>
      </div>
    </Modal>
  );
}; 